<template>
  <div>
    <a-table
      :columns="columns"
      :data-source="localStudents"
      :loading="loading"
      :pagination="false"
      row-key="enrollment_id"
      size="small"
      bordered
    >
      <template slot="name" slot-scope="text, record">
        <a-icon v-if="record.is_locked" type="lock" class="mr-1 text-warning" title="Locked" />
        <a-icon v-if="!record.is_allowed" type="stop" class="mr-1 text-danger" title="Not Allowed" />
        {{ record.student_name }}
      </template>

      <template slot="mark" slot-scope="text, record">
        <!-- Grade Entry (Text) -->
        <div v-if="isGradesOnly">
          <a-input
            v-model="record.grade"
            :placeholder="record.attendance === 0 ? 'Absent' : 'Enter Grade'"
            :disabled="record.attendance === 0 || record.is_locked || !record.is_allowed"
            style="width: 100%"
          />
        </div>

        <!-- Mark Entry (Number) -->
        <div v-else>
          <a-input-number
            v-model="record.mark"
            :min="0"
            :max="subjectConfig && subjectConfig.full_mark ? Number(subjectConfig.full_mark) : Infinity"
            :placeholder="record.attendance === 0 ? 'Absent' : 'Enter Mark'"
            :disabled="record.attendance === 0 || record.is_locked || !record.is_allowed"
            style="width: 100%"
          />
        </div>
      </template>
    </a-table>

    <div class="mt-4 text-right">
      <a-button type="primary" :loading="saving" @click="saveMarks" icon="save">
        Save Marks
      </a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarkEntryTable',
  props: {
    students: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    examData: {
      type: Object,
      required: true,
    },
    sessionId: {
      type: [Number, String],
      required: true,
    },
    subjectConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      saving: false,
      localStudents: [],
    }
  },
  computed: {
    isGradesOnly() {
      return this.subjectConfig && this.subjectConfig.grades_only === 1
    },
    columns() {
      return [
        {
          title: 'Student Code',
          dataIndex: 'student_code',
          key: 'student_code',
          width: '10%',
        },
        {
          title: 'Roll No',
          dataIndex: 'roll_no',
          key: 'roll_no',
          width: '10%',
        },
        {
          title: 'Name',
          key: 'name',
          scopedSlots: { customRender: 'name' },
          width: '30%',
        },
        {
          title: this.isGradesOnly ? 'Grades' : 'Marks',
          key: 'mark',
          scopedSlots: { customRender: 'mark' },
          width: '25%',
        },
      ]
    },
  },
  watch: {
    students: {
      immediate: true,
      handler(newList) {
        this.localStudents = newList.map((s) => ({
          ...s,
          mark: s.mark !== undefined && s.mark !== null ? s.mark : undefined,
          grade: s.grade !== undefined && s.grade !== null ? s.grade : undefined,
          attendance: s.attendance !== undefined && s.attendance !== null ? s.attendance : 1,
          enrollment_id: s.enrollment_id || s.id,
        }))
      },
    },
  },
  methods: {
    saveMarks() {
      this.saving = true

      const validStudents = this.localStudents.filter(
        (s) => {
          const hasMark = s.mark !== null && s.mark !== undefined && s.mark !== ''
          const hasGrade = s.grade !== null && s.grade !== undefined && s.grade !== ''
          return hasMark || hasGrade || s.attendance === 0
        }
      )

      const enrollMark = validStudents.map((s) => ({
        enrollment_id: s.enrollment_id,
        mark: s.attendance === 0 ? 0 : (s.mark !== undefined && s.mark !== null ? Number(s.mark) : null),
        attendance: s.attendance,
        grade: s.attendance === 0 ? null : (s.grade || null),
      }))

      if (enrollMark.length === 0) {
        this.$notification.warning({
          message: 'No Data',
          description: 'There are no valid marks or grades to save.',
        })
        this.saving = false
        return
      }

      const payload = {
        session_id: this.sessionId,
        class_section_exam_id: this.examData.class_section_exam_id,
        subject_id: this.examData.subject_id,
        enroll_mark: enrollMark,
      }

      this.$http
        .post('/api/staff/marks/store-marks', payload)
        .then(() => {
          this.$notification.success({
            message: 'Success',
            description: 'Data saved successfully',
          })
          this.$emit('refresh')
        })
        .catch((error) => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
